export default "__VITE_ASSET__ab3d4388__"